/* ==========================================================================
   KUSH BUNNA — Product Page Interactions
   ========================================================================== */
(function () {
  var pdp = document.querySelector('.kb-pdp');
  if (!pdp) return;

  var bagPlans = window.kbBagPlans || [
    { qty: 2, discount: 10 },
    { qty: 3, discount: 20 },
    { qty: 4, discount: 25 }
  ];

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.kbShopCurrency || 'USD'
    });
  }

  function yearlyPrice(unitCents, qty, discount) {
    return Math.round(unitCents * qty * (100 - discount) / 100);
  }

  /* ---------- Gallery thumbnail switching ---------- */
  function showMedia(targetId) {
    if (!targetId) return;
    pdp.querySelectorAll('.kb-pdp__main-img').forEach(function (img) {
      img.classList.toggle('kb-pdp__main-img--hidden', img.id !== 'kb-main-img-' + targetId);
    });
    pdp.querySelectorAll('.kb-pdp__thumb').forEach(function (t) {
      var on = t.getAttribute('data-target') === String(targetId);
      t.classList.toggle('kb-pdp__thumb--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  var thumbs = pdp.querySelectorAll('.kb-pdp__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showMedia(thumb.getAttribute('data-target'));
    });
  });

  pdp.querySelectorAll('.kb-pdp__swatch--btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      pdp.querySelectorAll('.kb-pdp__swatch--btn').forEach(function (b) {
        b.classList.remove('kb-pdp__swatch--on');
      });
      btn.classList.add('kb-pdp__swatch--on');
      showMedia(btn.getAttribute('data-target'));
    });
  });

  /* ---------- Quantity stepper ---------- */
  var qtyInput = pdp.querySelector('[data-qty-input]');
  var qtyMinus = pdp.querySelector('[data-qty-minus]');
  var qtyPlus = pdp.querySelector('[data-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });
  }

  /* ---------- Purchase type + bag cards ---------- */
  var purchaseRadios = pdp.querySelectorAll('[data-purchase-type]');
  var sellingPlanInput = pdp.querySelector('[data-selling-plan-input]');
  var deliverySelect = pdp.querySelector('[data-selling-plan-select]');
  var bagRadios = pdp.querySelectorAll('input[name="kb-bag-plan"]');

  function syncBagCard(qty) {
    bagRadios.forEach(function (radio) {
      radio.checked = parseInt(radio.getAttribute('data-bag-qty') || '0', 10) === qty;
    });
  }

  function syncPlan(qty, isSubscribe) {
    var target = isSubscribe ? 'subscribe-' + qty : 'onetime';
    purchaseRadios.forEach(function (radio) {
      radio.checked = radio.value === target;
    });
  }

  function updatePurchaseType() {
    var checked = pdp.querySelector('[data-purchase-type]:checked');
    if (!checked) return;

    var qty = parseInt(checked.getAttribute('data-sub-qty') || '1', 10);
    if (qtyInput) qtyInput.value = qty;
    if (checked.value.indexOf('subscribe') === 0) {
      syncBagCard(qty);
    } else {
      bagRadios.forEach(function (radio) {
        radio.checked = false;
      });
    }

    if (sellingPlanInput) {
      var isSub = checked.value.indexOf('subscribe') === 0;
      if (isSub && deliverySelect && deliverySelect.options.length) {
        var planIndex = Math.max(0, qty - 2);
        if (deliverySelect.options[planIndex]) {
          deliverySelect.selectedIndex = planIndex;
          sellingPlanInput.value = deliverySelect.options[planIndex].value;
        } else {
          sellingPlanInput.value = deliverySelect.value;
        }
      } else {
        sellingPlanInput.value = '';
      }
    }

    updatePriceDisplay(findMatchingVariant() || (window.kbProductVariants && window.kbProductVariants[0]));
  }

  purchaseRadios.forEach(function (radio) {
    radio.addEventListener('change', updatePurchaseType);
  });
  bagRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var qty = parseInt(radio.getAttribute('data-bag-qty') || '2', 10);
      syncPlan(qty, true);
      updatePurchaseType();
    });
  });
  if (deliverySelect) {
    deliverySelect.addEventListener('change', updatePurchaseType);
  }

  /* ---------- Variant switching ---------- */
  var optionInputs = pdp.querySelectorAll('.kb-pdp__option-input');
  var variantIdInput = pdp.querySelector('[data-variant-id-input]');
  var priceEl = pdp.querySelector('[data-price]');
  var compareEl = pdp.querySelector('[data-compare-price]');
  var saveBadge = pdp.querySelector('[data-save-badge]');
  var onetimePrice = pdp.querySelector('[data-onetime-price]');
  var addBtn = pdp.querySelector('[data-add-to-cart]');

  function getSelectedOptions() {
    var groups = {};
    optionInputs.forEach(function (input) {
      if (input.checked) {
        groups[input.getAttribute('data-option-index')] = input.value;
      }
    });
    return groups;
  }

  function findMatchingVariant() {
    if (!window.kbProductVariants) return null;
    var selected = getSelectedOptions();
    var keys = Object.keys(selected);
    if (!keys.length) return window.kbProductVariants[0] || null;
    return window.kbProductVariants.find(function (variant) {
      return keys.every(function (idx) {
        return variant.options[parseInt(idx, 10)] === selected[idx];
      });
    });
  }

  function updateBagAndPlanPrices(unitCents) {
    pdp.querySelectorAll('.kb-pdp__pack[data-bag-qty]').forEach(function (card) {
      var qty = parseInt(card.getAttribute('data-bag-qty'), 10);
      var discount = parseInt(card.getAttribute('data-yearly-discount'), 10);
      var saleEl = card.querySelector('[data-bag-sale]');
      var compareBagEl = card.querySelector('[data-bag-compare]');
      if (saleEl) saleEl.textContent = formatMoney(yearlyPrice(unitCents, qty, discount));
      if (compareBagEl) compareBagEl.textContent = formatMoney(unitCents * qty);
    });

    if (onetimePrice) onetimePrice.innerHTML = formatMoney(unitCents) + '<small>/ bag</small>';
    bagPlans.forEach(function (plan) {
      var el = pdp.querySelector('[data-subscribe-' + plan.qty + '-price]');
      if (el) el.innerHTML = formatMoney(yearlyPrice(unitCents, plan.qty, plan.discount)) + '<small>/ mo</small>';
    });
  }

  function selectedPurchasePrice(unitCents) {
    var checked = pdp.querySelector('[data-purchase-type]:checked');
    if (!checked || checked.value.indexOf('subscribe') !== 0) {
      return { price: unitCents, compare: 0, discount: 0 };
    }
    var qty = parseInt(checked.getAttribute('data-sub-qty') || '1', 10);
    var discount = parseInt(checked.getAttribute('data-yearly-discount') || '0', 10);
    return {
      price: yearlyPrice(unitCents, qty, discount),
      compare: unitCents * qty,
      discount: discount
    };
  }

  function updatePriceDisplay(variant) {
    if (!variant) return;

    updateBagAndPlanPrices(variant.price);

    var selected = selectedPurchasePrice(variant.price);
    if (priceEl) priceEl.textContent = formatMoney(selected.price);

    if (compareEl && saveBadge) {
      if (selected.compare > selected.price) {
        compareEl.textContent = formatMoney(selected.compare);
        compareEl.hidden = false;
        compareEl.classList.remove('kb-pdp__compare--hidden');
        saveBadge.textContent = 'Save ' + selected.discount + '%';
        saveBadge.hidden = false;
        saveBadge.classList.remove('kb-pdp__save--hidden');
      } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
        compareEl.classList.remove('kb-pdp__compare--hidden');
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        saveBadge.textContent = 'Save ' + pct + '%';
        saveBadge.hidden = false;
        saveBadge.classList.remove('kb-pdp__save--hidden');
      } else {
        compareEl.hidden = true;
        compareEl.classList.add('kb-pdp__compare--hidden');
        saveBadge.hidden = true;
        saveBadge.classList.add('kb-pdp__save--hidden');
      }
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    if (variant.featured_media_id) showMedia(variant.featured_media_id);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      updatePriceDisplay(findMatchingVariant());
    });
  });
  updatePurchaseType();

  /* ---------- Add to cart (AJAX) ---------- */
  var form = pdp.querySelector('#kb-product-form');

  function isSubscriptionSelected() {
    var checked = pdp.querySelector('[data-purchase-type]:checked');
    return !!(checked && checked.value.indexOf('subscribe') === 0);
  }

  function cartHasTote(cart) {
    var toteId = window.kbFreeToteVariantId;
    if (!toteId || !cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return item.variant_id === toteId || String(item.id) === String(toteId);
    });
  }

  function addFreeToteIfNeeded() {
    var toteId = window.kbFreeToteVariantId;
    if (!toteId || !isSubscriptionSelected()) {
      return Promise.resolve();
    }

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cartHasTote(cart)) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: toteId,
              quantity: 1,
              properties: { '_subscription_gift': 'free_tote' }
            }]
          })
        }).then(function (res) { return res.json(); });
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.dataset.originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () { return addFreeToteIfNeeded(); })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (addBtn) addBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart || {} }));
          var viewCart = pdp.querySelector('[data-view-cart]');
          if (viewCart) {
            viewCart.hidden = false;
            viewCart.classList.add('is-on');
          }
          setTimeout(function () {
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.dataset.originalText || 'Add to Cart';
            }
          }, 1800);
        })
        .catch(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = 'Try Again';
          }
        });
    });
  }
})();
